import React from 'react'
import 'draft-js/dist/Draft.css';

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// docs https://jpuri.github.io/react-draft-wysiwyg/#/docs

export default function MyEditor({
  editorState,
  setEditorState,
  customToolbars = null,
  editorStyle = {minHeight: '200px'},
  uploadCallback = () => { }
}) {
  let defaultOptions = ['inline', 'blockType', 'list', 'textAlign', 'emoji', 'remove', 'history'];
  if (customToolbars?.length) defaultOptions = [...customToolbars, ...defaultOptions]
  return (
    <Editor
      editorState={editorState}
      // editorStyle={editorStyle}
      // toolbarStyle={{
      //   position: 'sticky',
      //   top: 0,
      //   zIndex: 1000,
      // }}
      handlePastedText={() => false}
      toolbarClassName=""
      wrapperClassName="border border-gray-300 rounded-md overflow-hidden"
      editorClassName=" px-3 bg-white  max-h-[80vh] min-h-[400px] max-w-[100%]"
      toolbar={{
        options: defaultOptions,
        inline: { options: ['bold', 'italic', 'underline'] },
        blockType: {
          inDropdown: true,
          options: ['Normal','H2', 'H3', 'H4', 'H5', 'H6'],
          className: undefined,
          component: undefined,
          dropdownClassName: undefined,
        },
        list: {
          options: ['unordered', 'ordered'],
        },
        emoji: {
          className: undefined,
          component: undefined,
          popupClassName: 'absolute left-[-100px] lg:left-0',
        },
        image: {
          className: undefined,
          component: undefined,
          popupClassName: undefined,
          urlEnabled: false,
          uploadEnabled: true,
          alignmentEnabled: true,
          uploadCallback,
          previewImage: true,
          inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
          alt: { present: false, mandatory: false },
          defaultSize: {
            height: 'auto',
            width: 'auto',
          },
        },
      }}
      onEditorStateChange={(e) => {
        setEditorState(e)
      }}
    />
  )
}
